export enum AccountTypeEnum {
  Coach = 'coach',
  Therapist = 'therapist',
  Operations = 'operations',
  Dietitian = 'dietitian',
}

export enum ContactTypeEnum {
  Active = 'active',
  Archived = 'archived',
  Inactive = 'inactive',
  Deleted = 'deleted',
}
